import { render, staticRenderFns } from "./Pertashop.vue?vue&type=template&id=a083f0ce&scoped=true&"
import script from "./Pertashop.vue?vue&type=script&lang=js&"
export * from "./Pertashop.vue?vue&type=script&lang=js&"
import style0 from "./Pertashop.vue?vue&type=style&index=0&id=a083f0ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a083f0ce",
  null
  
)

export default component.exports